const ReviewResponseModel = {
  review: ["hasOne", "review"],
  applicants: ["hasMany", "applicant"],
}

export default ReviewResponseModel
